import { z } from "zod";

export type CallCenterStatus = z.infer<typeof CallCenterStatusSchema>;
export const CallCenterStatusSchema = z.object({
  // status: CallCenterStatusType;
  status: z.enum(["pending", "assigned", "solved", "rejected"]).nullable(),
  reject_comment: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
});

// export type CallCenterStatusType = "pending" | "assigned" | "solved" | "rejected";
